/**
 * OAuth API factory function
 */

import { OauthApi as OauthApiClient } from '@solink/vd-data-layer/api-clients/auth/oauth';

import settings from '@solinkcorp/settings';
import * as constants from 'vd-constants';

export default function OAuthApi() {
  return new OauthApiClient(settings.host, constants.REQUEST_TIMEOUT);
}
